import { DefaultTheme, css } from "styled-components";

export type Locale = "fa" | "en" | string;
export type LanguageName = "Persian" | "English";
export type LanguageDirection = "rtl" | "ltr";

export const languageUtil = {
  direction: (locale: Locale) => languages[locale].direction,
  isRTL: function (locale: Locale) {
    return this.direction(locale) === "rtl";
  },
  start: function (locale: Locale) {
    return this.isRTL(locale) ? "right" : "left";
  },
  end: function (locale: Locale) {
    return this.isRTL(locale) ? "left" : "right";
  },
};

export type Language = {
  locale: Locale;
  direction: LanguageDirection;
  name: LanguageName;
};

export type Languages = {
  [locale in Locale]: Language;
};

export const languages: Languages = {
  fa: {
    locale: "fa",
    name: "Persian",
    direction: "rtl",
  },
  en: {
    locale: "en",
    name: "English",
    direction: "ltr",
  },
};

export type SetLanguageDirection = {
  locale?: Locale;
  theme?: DefaultTheme;
};
export const setLanguageDirection = (props: SetLanguageDirection) =>
  !props.locale
    ? ""
    : css`
        text-align: ${languageUtil.start(props.locale)};
      `;
